import { FC } from 'react';
import styles from './index.module.scss';

interface TagProps {
  title: string;
  bgColor: string;
  color?: string;
}

export const Tag: FC<TagProps> = ({ title, bgColor, color = '#121214' }) => {
  return (
    <div className={styles.tag} style={{ backgroundColor: bgColor, color }}>
      {title}
    </div>
  );
};
